import styled from "styled-components";

export const Container = styled.p`
  white-space: pre-wrap;
  word-break: break-word;
`;
